module.exports = __webpack_public_path__ + "static/media/nft-marketplace.9c86a2fd.png";